// Valida CPF brasileiro (dígitos verificadores). Aceita com ou sem máscara.
export const isValidCpf = (value: string): boolean => {
    const cpf = (value || "").replace(/\D/g, "");
    if (cpf.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(cpf)) return false; // todos os dígitos iguais
    const calcDigit = (base: string, firstFactor: number): number => {
        let total = 0;
        let factor = firstFactor;
        for (const digit of base) {
            total += parseInt(digit, 10) * factor;
            factor -= 1;
        }
        const rest = (total * 10) % 11;
        return rest === 10 ? 0 : rest;
    };
    const d1 = calcDigit(cpf.slice(0, 9), 10);
    if (d1 !== parseInt(cpf[9], 10)) return false;
    const d2 = calcDigit(cpf.slice(0, 10), 11);
    return d2 === parseInt(cpf[10], 10);
};

// Aplica a máscara 000.000.000-00 progressivamente
export const maskCpf = (value: string): string => {
    const cpf = (value || "").replace(/\D/g, "").slice(0, 11);
    return cpf
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};
